import jApi from './jApi';

export default {
  getCompanyProfileDetail() {
    const api = jApi.generateApi();
    return api.get('company/studio/detail')
      .then(res => res.data);
  },
  getCompanyBanner(params) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/company-banner', params)
      .then(res => res.data);
  },
  updateCompanyProfile(req) {
    const api = jApi.generateApi();
    return api.post('company/studio/update', req)
      .then(res => res.data);
  },
  createCompanyBanner(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/company-banner', req)
      .then(res => res.data);
  },
  updateCompanyBanner(req, id) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/company-banner/${id}`, req)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiCompanyProfile.js